(ns ycweb.app.admin.wholesale.common.products
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]
   [ycweb.util.date :as yud]
   [ycweb.util.urlstate :as urlstate]))


;;------------------------------------------------------------------------------------------------------------------
;;                                     Variation Stock: Information
;;------------------------------------------------------------------------------------------------------------------

(rum/defcs stats-row < rum/reactive (rum/local {} ::state) [s app-atom {:keys [helper-message] :as stat} has-helpers?]
  (let [local-atom (::state s)
        {:keys [open?]} (rum/react local-atom)]
    (list
      [:tr.stats-table__row
       (when has-helpers?
         [:th
          {:style {:width "30px"}}
          (when helper-message
            [:i
             {:title "Click me"
              :on-click #(swap! local-atom update :open? not)
              :class (yuc/bem :icon [:help :is-dark :default :block])}])])
       [:th.stats-table__th (:title stat)]
       [:td.stats-table__td.u-text-right (:stat stat)]]
      (when (and open? helper-message)
        [:tr.stats-table__row
         [:td.stats-table__td
          {:colSpan 3}
          (feedback/feedback :info (:title helper-message)
            [:div
             (:description helper-message)
             (when (yuc/presence (:points helper-message))
               (into
                 [:ul]
                 (map (fn [point] [:li point]) (:points helper-message))))])]]))))

(rum/defc stats-card < rum/reactive
  [app-atom {:keys [title stats-content custom-content url url-action url-params view-permission?]}]
  [:article.stats-table-card.flex-grid-content
   [:header.stats-table-card__header
    {:class (yuc/bem :flex-grid-group [:valign-middle :align-left])}
    [:div
     {:class (yuc/bem :flex-grid-block [:grow-1 :fluid :flush])}
     [:div.flex-grid-content
      [:h2.stats-table-card__title
       {:class (yuc/bem :yc-heading [:flush :small])}
       title]]]
    (when
     (and
       view-permission?
       (or url url-action))
      [:div
       {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid :flush])}
       [:div.flex-grid-content
        [:a.icon-link
         (merge
           (cond
             url
             {:href url :target "_blank"}

             url-action
             (merge
               {:target "_blank"}
               (urlstate/href-props app-atom "wholesale" url-action url-params)))
           {:class (yuc/bem :icon-block-link [:size-default])})
         [:i {:class (yuc/bem :icon [:eye :is-dark :default :block])}]
         [:span.u-hidden-from-view "View"]]]])]
   [:div.stats-table__content
    (when stats-content
      (let [has-helpers?
            (->>
              stats-content
              (map :helper-message)
              (remove nil?)
              (empty?)
              (not))]
        (into
          [:table.stats-table
           [:tbody
            (map #(stats-row app-atom % has-helpers?) stats-content)]])))
    (when custom-content
      custom-content)]])

(defn stock-stats [app-atom details view-permission?]
  [:div.flex-grid-content
   (stats-card app-atom
     {:title (str "Stock In All Warehouse")
      :url (str (:weber/url details) "/admin/inspect/view/" (:variation/id details))
      :view-permission? view-permission?
      :stats-content
      [{:title "On Hand:" :stat (:stock/on-hand details)
        :helper-message
        {:title "Stock on hand:"
         :description "All stock that we have, but in different states. A few examples:"
         :points
         ["Stock that is ready to be assigned to Client Orders"
          "Stock that has just been received, but may be in processing (such as being replugged)"
          "Stock that is in a 'Broken' location, and needs processing"
          "Stock that has been received into a location, without the order being fully received"]}}
       {:title "Freestock:" :stat (:stock/available details)
        :helper-message
        {:title "Available Freestock"
         :description "Stock on hand, minus any stock allocated OR assigned to client orders"
         :points
         ["Allocated: Orders in status 'Ready to Ship', ready to be picked or have been picked for"
          "Assigned: Orders in status 'Order Placed' and items added to the order"]}}
       {:title "On Order:" :stat (:stock/on-order details)
        :helper-message
        {:title "Incoming Stock"
         :description "Stock that is on it's way to us, but has not been received by the warehouse"
         :points
         ["Any partial stock received will reflect in 'On Hand', and not in 'On Order'"]}}
       {:title "Allocated:" :stat (:stock/allocated details)
        :helper-message
        {:title "Allocated Stock"
         :description "Stock allocated to a Client Order that is"
         :points
         ["Status 'Ready to Ship'"
          "Ready to be picked for or has already been picked/packed"
          "Has not been sent to the customer"]}}
       {:title "Claimed:" :stat (:stock/claimed details)
        :helper-message
        {:title "Stock Claimed"
         :description "Stock Claimed on a Client Order that is"
         :points ["Status 'Order Placed'"]}}
       {:title "Non-Picking Stock:" :stat (:stock/non-picking-stock details 0)
        :helper-message
        {:title "Non-Picking Stock"
         :description "Stock that is in a non pickable location"
         :points ["Locations such as 'Broken', 'Unallocated'"]}}
       {:title "Next delivery date:"
        :stat
        (cond
          (yuc/presence (:stock/next-delivery-date details))
          (yud/date-format (:stock/next-delivery-date details) "dd MMM YYYY")

          :else
          "N/A")}
       {:title "Last delivery date:"
        :stat
        (cond
          (yuc/presence (:stock/last-delivery-date details))
          (yud/date-format (:stock/last-delivery-date details) "dd MMM YYYY")

          :else
          "N/A")}]})])

(defn sales-stats [app-atom details view-permission?]
  [:div.flex-grid-content
   (stats-card app-atom
     {:title (str "Sales")
      :url (str (:weber/url details) "/admin/inspect/view/" (:variation/id details))
      :view-permission? view-permission?
      :stats-content
      [{:title "Cover:" :stat (:variation/cover details)
        :helper-message
        {:title "Monthly Cover"
         :description "The number of months this SKU has cover for"
         :points ["Calculated Based on the average monthly rate of sale and the stock currently available"]}}
       {:title "Monthly Rate of Sale:" :stat (:monthly/rate-of-sale details)
        :helper-message
        {:description "Sales for this SKU over the last 6 months, averaged out."}}
       {:title "ES Sales 180:" :stat (:sales/days-180 details)
        :helper-message
        {:description "Total quantity of units sold in the last 180 days"}}
       {:title "ES Sales 60:" :stat (:sales/days-60 details)
        :helper-message
        {:description "Total quantity of units sold in the last 60 days"}}
       {:title "Unique Customers 180:" :stat (:unique/customers-180 details)}
       {:title "Unique Months 180:" :stat (:unique/months-180 details)}
       {:title "Unique Orders 180:" :stat (:unique/orders-180 details)}]})])

(rum/defcs variation-info-body < rum/reactive (rum/local {} ::state) [s app-atom]
  (let [local-atom (::state s)
        {:keys [open?]} (rum/react local-atom)
        {:keys [details error warning]} (cmn/curact (grid/modal-cursor app-atom) :config)
        view-permission? (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
        yc-details (:yuppiechef details)]

    [[:div.u-margin-top-24
      [:h2.u-text-center
       {:class (yuc/bem :heading [:standard])}
       (str (:variation/name details) ": " (:product/name details))]]
     [(cond
        error
        [:div
         {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
         [:div
          {:class (yuc/bem :flex-grid-block [:m-1-1])}
          [:div.flex-grid-content
           (feedback/feedback :error
             [:b (:title error)]
             [:div
              [:p (:message error)]
              (when-let [orders (seq (:stock/holding-orders details))]
                [:div
                 [:p "Stock is held by:"]
                 (into [:ul]
                   (map
                     (fn [{:holding-order/keys [refid customer status backorder? qty] :as order}]
                       [:li
                        [:a
                         (merge
                           {:target "_blank"}
                           (urlstate/href-props app-atom "wholesale" "client_order_overview"
                             {:uuid (:holding-order/uuid order)}))
                         (str "SO-" refid)]
                        (str ": " customer ", " (if backorder? "Backorder" status) ", " qty " outstanding")])
                     orders))])])]]]

        warning
        [:div
         {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
         [:div
          {:class (yuc/bem :flex-grid-block [:m-1-1])}
          [:div.flex-grid-content
           (feedback/feedback :warning
             [:b (:title warning)]
             [:div
              [:p (:message warning)]])]]])

      [:div
       {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (yuc/bem :flex-grid-block [:m-1-1])}
        [:div.flex-grid-content
         (stats-card app-atom
           (yuc/maybe assoc
             {:title "Product Info"
              :url-params {:uuid (:variation/uuid details)}
              :url-action "product_overview"
              :view-permission? view-permission?
              :stats-content
              [;;TODO: Product's aren't linked to categories yet
               {:title "Category:" :stat (:category/fullname details)}
               {:title "Unit of measure:" :stat (:unit-of-measure details)}
               {:title "Brand:" :stat (:brand/name details)}
               {:title "Average cost:" :stat (trf/fromcurrency (:variation/costprice details))}
               {:title "Wholesale Price:" :stat (yuc/number-format (trf/fromcurrency (:variation/price details)) 0 "." "")}
               {:title "ES margin:" :stat (str (:variation/margin details) "%")}]}
             :custom-content
             (when yc-details
               [:div
                [:div
                 {:class (yuc/bem :admin-action-item__header [])
                  :on-click #(swap! local-atom update :open? not)}
                 [:span.admin-action-item__icon
                  [:i
                   {:class (yuc/bem :icon [:block (if open? :minus :plus) :is-dark])}]]
                 [:h2.admin-action-item__title "Yuppiechef"]]
                (when open?
                  (stats-card app-atom
                    {:title "Product Stats"
                     :url (:yc-url yc-details)
                     :view-permission? true
                     :stats-content
                     [{:title "YC Free Stock:" :stat (:freestock yc-details)}
                      {:title "YC Sales 180:" :stat (:yc-sales-180 yc-details)}
                      {:title "YC Sales 60:" :stat (:yc-sales-60 yc-details)}
                      {:title "YC Sellable 180:" :stat (:yc-sellable-180 yc-details)}
                      {:title "ES Sales 180:" :stat (:unit-of-measure yc-details)}
                      {:title "ES Sales 60:" :stat (:brand/name yc-details)}
                      {:title "ES Sellable 180:" :stat (:es-sellable-180 yc-details)}
                      {:title "ES Last Sellable:" :stat (:es-last-sellable yc-details)}
                      {:title "YC Store Plans:" :stat (:yc-store-plans yc-details)}
                      {:title "YC Store Stock:" :stat (:yc-store-stock yc-details)}
                      {:title "YC RSP:" :stat (:yc-rsp yc-details)}
                      {:title "YC Content Live:" :stat (:yc-content-live yc-details)}
                      {:title "YC Variation Available:" :stat (:yc-variation-available yc-details)}
                      {:title "YC Not Available Reason:" :stat (:yc-not-available-reason yc-details)}
                      {:title "YC Reviews:" :stat (:yc-reviews yc-details)}
                      {:title "YC Stars:" :stat (:yc-stars yc-details)}]}))])))]]]

      [:div
       {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
       [:div
        {:class (yuc/bem :flex-grid-block [:m-1-2])}
        (stock-stats app-atom details view-permission?)]
       [:div
        {:class (yuc/bem :flex-grid-block [:m-1-2])}
        (sales-stats app-atom details view-permission?)]]]]))

(defmethod grid/modal-config :admin.wholesale/variation-stock-info [_ _ _]
  {:body variation-info-body
   :footer grid/list-modal-footer
   :modal-type :variable
   :max-width 920})